<template>
  <!-- 头部 -->
  <div>
    <div class="header-wrap">
      <div :class="['header', { headerFix: fixFlag }]">
        <div class="content">
          <div class="l">
            <img src="@/assets/appimg/index/icon/logo.jpg" class="logo" />
          </div>
          <div class="r">
            <el-button type="primary" round class="use_btn" @click="useClick" style="margin-left: 0">申请试用</el-button>
          </div>
        </div>
      </div>
    </div>
    <CustCare ref="consultRef" />
    <Apply ref="applyRef" />
  </div>
</template>
<script>
import CustCare from '@/views/app/components/custCare'
import Apply from '@/views/app/components/apply'
export default {
  name: "HeaderApp",
  components: { CustCare, Apply },
  data () {
    return {
      fixFlag: false
    }
  },
  mounted () {
    window.addEventListener('scroll', this.handleScroll, { passive: true })
    this.handleScroll()
  },
  beforeDestroy () {
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    handleScroll () {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0
      this.fixFlag = scrollTop > 10
    },
    // 打开咨询弹窗
    consultingOpen() {
      this.$refs.consultRef.open();
    },
    // 试用
    useClick () {
      this.$refs.applyRef.useClick();
    },
  }
}
</script>
<style lang="scss" scoped>
/** 头部 **/
.header-wrap {
  height: 2.5rem;
}
.header {
  height: 2.5rem;
  padding: 0 1rem;
  box-sizing: border-box;
  //display: flex;
  //align-items: center;
  //box-sizing: border-box;
  .content {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .l {
      display: flex;
      align-items: center;
      height: 30px;

      .logo {
        width: 10.5rem;
        height: auto;
        display: block;
        object-fit: contain;
      }
    }
    .r {
      display: flex;
      align-items: center;
      .use_btn {
        background: #1D2DC9;
        border-color: #1D2DC9;
        margin-right: 0.25rem;
      }
      .el-button {
        width: 4rem;
        height: 1.5rem;
        font-size: 0.6rem;
        padding: 0 !important;
        line-height: 1;
        text-align: center;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .el-button.is-round {
        padding: .45rem .8rem;
      }
      .login-btn {
        border: 1px solid #E3E3E3;
      }
    }
  }
}

.headerFix {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  background: #fff;
  box-shadow: rgb(0 0 0 / 4%) 0px 4px 12px 0px;
  z-index: 99;
}
</style>



// WEBPACK FOOTER //
// src/views/app/components/header.vue